import { render, staticRenderFns } from "./Cloudregion.vue?vue&type=template&id=0ca598f0&"
import script from "./Cloudregion.vue?vue&type=script&lang=js&"
export * from "./Cloudregion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports